import { render, staticRenderFns } from "./t-orm-wrapper.vue?vue&type=template&id=ee5c1bfc&lang=pug&"
import script from "./t-orm-wrapper.vue?vue&type=script&lang=js&"
export * from "./t-orm-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./t-orm-wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports